/* @flow */
import cx from 'classnames';
import * as React from 'react';

import BoxHeader from 'components/BoxHeader.jsx';
import Image from 'components/Image.jsx';

import './styles/Box.scss';

import type { Props as BoxHeaderProps } from 'components/BoxHeader.jsx'; // eslint-disable-line no-unused-vars

// prettier-ignore
export type Props = {
  children?: React.Node,
  className?: string,
  color?: 'polar-bear' | 'white',
  headerImage?: string,
  headerTextAlign?: 'left' | 'center' | 'right',
  onImageLoad?: ?(() => void),
  size?: 'xlarge' | 'large' | 'xmedium' | 'medium' | 'small' | 'xsmall',
  textAlign?: 'left' | 'center' | 'right',
  /* :: ...$Exact<BoxHeaderProps>, */
};

export default class Box extends React.Component<Props> {
  static defaultProps = {
    color: 'white',
    textAlign: 'center',
  };

  render() {
    const {
      children,
      className,
      color,
      dark, // eslint-disable-line react/prop-types
      glyph, // eslint-disable-line react/prop-types
      glyphColor, // eslint-disable-line react/prop-types
      headerImage,
      headerTextAlign,
      image, // eslint-disable-line react/prop-types
      imageSize, // eslint-disable-line react/prop-types
      onImageLoad,
      size,
      subtext, // eslint-disable-line react/prop-types
      title, // eslint-disable-line react/prop-types
      textAlign,
    } = this.props;

    return (
      <div
        className={cx(
          'Box',
          color && `Box--${color}`,
          size && `Box--${size}`,
          textAlign && `Box--${textAlign}`,
          className
        )}>
        {headerImage && (
          <Image src={headerImage} className="Box-headerImage" onLoad={onImageLoad} />
        )}
        {(glyph || image || title || subtext) && (
          <BoxHeader
            glyph={glyph}
            glyphColor={glyphColor}
            image={image}
            imageSize={imageSize}
            title={title}
            subtext={subtext}
            align={headerTextAlign}
            dark={dark}
            flush
          />
        )}
        {children}
      </div>
    );
  }
}
